// Thin wrapper around window.location so it can be mocked in tests —
// jsdom locks window.location, making the global impossible to redefine directly.
export const getWindowLocation = () => window.location;
